<input
  #fileInput
  type="file"
  [id]="inputId || null"
  [attr.name]="name"
  [attr.accept]="accept"
  [attr.title]="title || null"
  [ngClass]="cssClass"
  [class.file-input--overlay]="overlay"
  [disabled]="disabled"
  (change)="fileSelected.emit($event)"
  (click)="clickEvent.emit($event)"
/>
